// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '../../Geometry';
import { TreemapCalculator } from '../TreeMap/TreemapCalculator';
export class BaseMap {
    constructor() {
        this._items = [];
        this.calculator = new TreemapCalculator();
        this.Rectangle = Rectangle.Empty();
    }
    get items() {
        return [...this._items];
    }
    get Weight() {
        return this._items.reduce((sum, item) => sum + item.Weight, 0);
    }
    addItem(item) {
        this._items.push(item);
    }
    recalculateTreeMap(rect) {
        const visibleItems = this._items.filter((item) => item.Visible);
        this.calculator.recalculate(visibleItems, rect);
    }
    isVisible() {
        return this._items.some((item) => item.Visible);
    }
    getVisibleCount() {
        return this._items.filter((item) => item.Visible).length;
    }
}
